import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import { FONT } from '../../styles/color';
import { Medium } from '../../components/UI/Text';

import { POST_TYPE } from '../../utils/constants';

const Container = styled.div`
	width: 100%;
	border-top: 2px solid ${ FONT.mid };
	border-bottom: 2px solid ${ FONT.mid };
	height: auto;
	max-height: 556px;
	overflow-y: hidden;
`;

const TableHeader = styled.div`
	width: 100%;
	height: 50px;
	border-bottom: 2px solid ${ FONT.mid };
	display: grid;
	grid-template-columns: 80px 120px 400px 150px 150px;
`;

const TableItem = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: ${props => props.align === 'left' ? 'flex-start' : 'center'};
	align-items: center;
	cursor: pointer;
`;

const TableDataWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;	
`;

const TableData = styled.div`
	width: 100%;
	height: 50px;
	display: grid;
	grid-template-columns: 80px 120px 400px 150px 150px;
`;

const Empty = styled.div`
	width: 100%;
	height: 200px;
	display: flex;
	justify-content: center;
	align-items: center;
`;

function TableRow(props) {
	const navigate = useNavigate();
	const post = props.data;

	const onClickRow = (boardId) => {
		navigate(`/board/${boardId}`);
	};

	return (
		<TableData onClick={() => onClickRow(post.postId)}>
			<TableItem><Medium>{ post.postId }</Medium></TableItem>
			<TableItem><Medium>{ POST_TYPE[post.postType] }</Medium></TableItem>
			<TableItem align="left"><Medium>{ post.postTitle }</Medium></TableItem>
			<TableItem><Medium>{ post.authorId }</Medium></TableItem>
			<TableItem><Medium>{ post.writtenAt.split('T')[0] }</Medium></TableItem>
		</TableData>
	);
}


export default function TableWrapper(props) {
  	return (
		<Container>
			<TableHeader>
				<TableItem><Medium>No</Medium></TableItem>
				<TableItem><Medium>구분</Medium></TableItem>
				<TableItem><Medium>제목</Medium></TableItem>
				<TableItem><Medium>작성자</Medium></TableItem>
				<TableItem><Medium>작성일</Medium></TableItem>
			</TableHeader>
			<TableDataWrapper>
				{
					props.data.length === 0 ? (
						<Empty>
							<Medium>게시물이 없습니다.</Medium>
						</Empty>
					):	
					props.data.map((post, index) => (
						<TableRow key={ index } data={ post } />
					))
				}
			</TableDataWrapper>
		</Container>
  	);
}
